import { ref } from '#imports';

export const useCountdown = () => ({
  nowTime: ref(0),
  timeout: ref(null),
  onTimerStartCallback: null,
  onTimerTickCallback: null,
  onTimerEndCallback: null,

  destroyTimer() {
    clearTimeout(this.timeout.value);
    this.timeout.value = null;
  },
  startTimer(timerDuration = 1) {
    this.nowTime.value = timerDuration;

    this.onTimerStartCallback?.();

    this.nextTimerTick();
  },
  nextTimerTick() {
    if (this.nowTime.value < 1) return this.onTimerEndCallback?.();

    this.timeout.value = setTimeout(() => {
      this.nowTime.value--;

      this.onTimerTickCallback?.();
      this.nextTimerTick();
    }, 1000);
  },
});
